import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IClientProfileInfo } from "src/app/models/client/client-info";

@Component({
  selector: "app-client-info-form",
  templateUrl: "./client-info-form.component.html",
  styleUrls: ["./client-info-form.component.scss"],
})
export class ClientInfoFormComponent {
  @Input() clientProfileInfo: Partial<IClientProfileInfo> | null = null;
  @Input() isLoading = false;

  @Output() editClick = new EventEmitter();

  get fullName() {
    const { firstName = "", lastName = "" } = this.clientProfileInfo ?? {};

    return `${firstName} ${lastName}`.trim();
  }
}
